import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    fieldSpacing: {
        padding: '5px'
    },
btn:{
color:"#FFFFFF !Important"
   }
}));

export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {

            // MuiButton:{
            //     root:{
            //         color:"#FFFFFF!Important"
            //     },
            // },
            MuiDialog:{
                paper:{
                    borderTop: selectedTheme.palette.primary.main + ' solid 3px',
                }
              },
        },
    })
}